import { getColumns, uniqueName } from './GlobalModuleHomePage.Grid';
import actions from '../../../store/actions';
import appRoutes from '../../../infrastructure/constants/appRoutes';
import GridRefresh from '../../../store/state/events/GridRefresh';
import history from '../../../infrastructure/helpers/react/history';
import identityStorage from '../../../infrastructure/authorization/identityStorage';
import React from 'react';
import ReportConfigGridItem from '../../../types/report/ReportConfigGridItem';
import ServerDataGrid from '../../Common/DataGrid/ServerDataGrid/ServerDataGrid';
import store from '../../../store/store';
import urlHelper from '../../../infrastructure/helpers/common/urlHelper';
import writeUserRoles from '../../../infrastructure/constants/identity/writeUserRoles';
import DownloadModal from '../../Common/Modals/DownloadModal/DownloadModal';
import httpClient from '../../../infrastructure/helpers/common/httpClient';
import { AxiosResponse } from 'axios';
import ReportConfig from '../../../types/report/ReportConfig';
import { reportType } from '../../../infrastructure/constants/reportType';
import messageHelper from '../../Common/Message/MessageHelper';
import ReportPageState from '../Pages/ReportPage/ReportPageState';

interface State {
    name: string;
    showDownloadPopup: boolean;
    reportConfigId: number;
    message: string;
    description: string;
    showAddConfigButton: boolean;
    showSpinnerOnDownload: boolean;
}

class GlobalModuleHomePage extends React.Component<any, State> {
    constructor(props: any) {
        super(props);

        this.state = {
            name: '',
            showDownloadPopup: false,
            reportConfigId: 0,
            message: '',
            description: '',
            showAddConfigButton: false,
            showSpinnerOnDownload: false
        };

        this.onDownloadClick = this.onDownloadClick.bind(this);
        this.onDownloadTypeSelected = this.onDownloadTypeSelected.bind(this);
        this.onRecordsFetched = this.onRecordsFetched.bind(this);
        this.onCreateNewClick = this.onCreateNewClick.bind(this);
        this.onMouseLeaveDerscription = this.onMouseLeaveDerscription.bind(this);
    }

    onRecordsFetched(records: ReportConfig[]) {
        if (records.length === 0) {
            this.setState({ showAddConfigButton: true, description: records?.[0]?.description as string });
        }
    }

    onCreateNewClick() {

        var config = { reportConfig: { type: reportType.globalModule } as ReportConfig } as ReportPageState;

        store.dispatch({ type: actions.globalModule.new, payload: config });

        var route = appRoutes.global.dataSources;
        history.push(route);
    }

    onEditClick(id: number): void {

        let route = urlHelper.buildUrl(appRoutes.reporting.edit, { id: id });

        history.push(route);
    }

    onDownloadClick(id: number): Promise<void> {

        this.setState({ showDownloadPopup: true, reportConfigId: id });
        return Promise.resolve();
    }

    async onDownloadTypeSelected(downloadAsFragmented: boolean, useReleasedConfig: boolean) {

        this.setState({ showSpinnerOnDownload: true, showDownloadPopup: false });

        let mainPart = `report/global-module-${downloadAsFragmented ? 'export-fragmented' : 'export-full'}`;

        let route = urlHelper.buildRoute([mainPart, this.state.reportConfigId, useReleasedConfig]);

        await httpClient.download(route);

        this.setState({ showSpinnerOnDownload: false });
    }

    onSuccess(response: AxiosResponse): void {

        let payload: GridRefresh = {
            uniqueName: uniqueName,
            useCurrentPage: true
        };

        store.dispatch({ type: actions.grid.refresh, payload: payload });
    };


    async onMouseLeaveDerscription(gridInfo: ReportConfigGridItem, description: string) {

        if (this.state.description && this.state.description !== description) {
            gridInfo.description = description;

            let url = urlHelper.buildRoute(['report', 'update', 'description']);

            await httpClient.put(url, gridInfo);

            messageHelper.showMesage(`Description "${description}" for config with Id: ${gridInfo.id} was saved.`, false, true);

            this.setState({ description });
        }
    }


    onViewReleasedClick(id: number): void {

        let route = urlHelper.buildUrl(appRoutes.reporting.edit, { id: id, released: true });

        history.push(route);
    }

    render(): JSX.Element {

        let identity = identityStorage.get();

        return (
            <>
                <h3>Global Module Config</h3>

                {
                    writeUserRoles.includes(identity.userRole) && this.state.showAddConfigButton &&
                    <div className="mt-4">
                        <button type="button" className="btn cb-btn margin-bottom-10px-important" onClick={this.onCreateNewClick}>Create New Global Module Config</button>
                    </div>
                }

                <div className="mb-4">
                    <ServerDataGrid
                        columns={getColumns(
                            this.onEditClick,
                            this.onDownloadClick,
                            this.onViewReleasedClick,
                            this.state.showSpinnerOnDownload,
                            this.onMouseLeaveDerscription)}
                        uniqueName={uniqueName}
                        dataSourceRoute="report/global-module-page"
                        pageSize={10}
                        getKey={x => x.id}
                        onRecordsFetched={this.onRecordsFetched} />
                </div>

                <DownloadModal
                    onClose={() => { this.setState({ showDownloadPopup: false }) }}
                    onDownload={this.onDownloadTypeSelected}
                    isOpen={this.state.showDownloadPopup}
                    showVersionSelection={true} />
            </>
        );
    }
}

export default GlobalModuleHomePage;
